import React from 'react';
import { HeroSection } from './HeroSection';
import { ValidatorBar } from './ValidatorBar';
import { ProblemSection } from './ProblemSection';
import { ProductSection } from './ProductSection';
import { ValueStack } from './ValueStack';
import { AuthoritySection } from './AuthoritySection';
import { TestimonialsSection } from './TestimonialsSection';
import { GuaranteeSection } from './GuaranteeSection';
import { FAQSection } from './FAQSection';
import { ClosingSection } from './ClosingSection';
import { StickyMobileCTA } from './StickyMobileCTA';
import { PurchaseNotification } from './PurchaseNotification';
export function LandingPage() {
  return <div className="min-h-screen bg-warm-50 font-sans text-charcoal selection:bg-primary/20 selection:text-primary" data-id="element-108">
      <HeroSection data-id="element-109" />
      <ValidatorBar data-id="element-110" />
      <ProblemSection data-id="element-111" />
      <ProductSection data-id="element-112" />
      <ValueStack data-id="element-113" />
      <AuthoritySection data-id="element-114" />
      <TestimonialsSection data-id="element-115" />
      <GuaranteeSection data-id="element-116" />
      <FAQSection data-id="element-117" />
      <ClosingSection data-id="element-118" />

      {/* Fixed UI Elements */}
      <StickyMobileCTA data-id="element-119" />
      <PurchaseNotification data-id="element-120" />
    </div>;
}